import { type Ref, onMounted, onUnmounted } from 'vue';

/**
 * Observes a video element and plays/pauses it as it enters or exits the viewport.
 */
export function useVideoAutoplay(videoRef: Ref<HTMLVideoElement | null>) {
  let observer: IntersectionObserver | null = null;

  onMounted(() => {
    if (!videoRef.value) return;

    observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          videoRef.value?.play().catch(() => {});
        } else {
          videoRef.value?.pause();
        }
      },
      { threshold: 0 },
    );

    observer.observe(videoRef.value);
  });

  onUnmounted(() => {
    observer?.disconnect();
    observer = null;
  });
}
